export default class Activity {
  _id = "";
  _titre = "";
  _titreUpper = "";
  _description = "";
  _descriptionUpper = "";
  _typeTraitement = "";
  _materiel = "";
  _cover = "";
  _defaultCover = "";
  _allMedia = [];
  _duree = "";
  _nombreSeances = "";
  _typeIntervention = "";
  _age = "";
  _ageLibelle = [];
  _fonctionsCognitives = "";
  _fonctionsCognitivesUpper = "";
  _proceduresUtilisees = "";
  _proceduresUtiliseesUpper = "";
  _etapes = [];
  _difficulte = "";
  _moyensMesure = "";
  _precautions = "";
  _gestionCapicitesTransfert = "";
  _cadreTheorique = "";
  _sourcesBibliographique = [];
  _medias = "";
  _createdOn = "";
  _updateOn = "";
  _comments = 0;
  _likes = 0;
  _userId = "";
  _userName = "";
  _classification = "";
  _tags = [];
  _terms = false;
  _disabled = false;
  _draft = false;
  mediaCover = null;

  constructor() {}

  get id() {
    return this._id;
  }

  set id(value) {
    this._id = value;
  }

  get titre() {
    return this._titre;
  }

  get allMedia() {
    return this._allMedia;
  }

  set allMedia(value) {
    this._allMedia = value;
  }

  set titre(value) {
    this._titre = value;
  }

  get titreUpper() {
    return this._titreUpper;
  }

  set titreUpper(value) {
    this._titreUpper = value;
  }

  get description() {
    return this._description;
  }

  set description(value) {
    this._description = value;
  }

  get terms() {
    return this._terms;
  }

  set terms(value) {
    this._terms = value;
  }

  get descriptionUpper() {
    return this._descriptionUpper;
  }

  set descriptionUpper(value) {
    this._descriptionUpper = value;
  }

  get cover() {
    return this._cover;
  }

  set cover(value) {
    this._cover = value;
  }

  get defaultCover() {
    return this._defaultCover;
  }

  set defaultCover(value) {
    this._defaultCover = value;
  }

  get typeTraitement() {
    return this._typeTraitement;
  }

  set typeTraitement(value) {
    this._typeTraitement = value;
  }

  get materiel() {
    return this._materiel;
  }

  set materiel(value) {
    this._materiel = value;
  }

  get duree() {
    return this._duree;
  }

  set duree(value) {
    this._duree = value;
  }

  get nombreSeances() {
    return this._nombreSeances;
  }

  set nombreSeances(value) {
    this._nombreSeances = value;
  }

  get typeIntervention() {
    return this._typeIntervention;
  }

  set typeIntervention(value) {
    this._typeIntervention = value;
  }

  get age() {
    return this._age;
  }

  set age(value) {
    this._age = value;
  }

  get ageLibelle() {
    return this._ageLibelle;
  }

  set ageLibelle(value) {
    this._ageLibelle = value;
  }

  get fonctionsCognitives() {
    return this._fonctionsCognitives;
  }

  set fonctionsCognitives(value) {
    this._fonctionsCognitives = value;
  }

  get fonctionsCognitivesUpper() {
    return this._fonctionsCognitivesUpper;
  }

  set fonctionsCognitivesUpper(value) {
    this._fonctionsCognitivesUpper = value;
  }

  get proceduresUtilisees() {
    return this._proceduresUtilisees;
  }

  set proceduresUtilisees(value) {
    this._proceduresUtilisees = value;
  }

  get proceduresUtiliseesUpper() {
    return this._proceduresUtiliseesUpper;
  }

  set proceduresUtiliseesUpper(value) {
    this._proceduresUtiliseesUpper = value;
  }

  get etapes() {
    return this._etapes;
  }

  set etapes(value) {
    this._etapes = value;
  }

  get difficulte() {
    return this._difficulte;
  }

  set difficulte(value) {
    this._difficulte = value;
  }

  get moyensMesure() {
    return this._moyensMesure;
  }

  set moyensMesure(value) {
    this._moyensMesure = value;
  }

  get precautions() {
    return this._precautions;
  }

  set precautions(value) {
    this._precautions = value;
  }

  get gestionCapicitesTransfert() {
    return this._gestionCapicitesTransfert;
  }

  set gestionCapicitesTransfert(value) {
    this._gestionCapicitesTransfert = value;
  }

  get cadreTheorique() {
    return this._cadreTheorique;
  }

  set cadreTheorique(value) {
    this._cadreTheorique = value;
  }

  get sourcesBibliographique() {
    return this._sourcesBibliographique;
  }

  set sourcesBibliographique(value) {
    this._sourcesBibliographique = value ? value : [];
  }

  get medias() {
    return this._medias;
  }

  set medias(value) {
    this._medias = value;
  }

  get createdOn() {
    return this._createdOn;
  }

  set createdOn(value) {
    this._createdOn = value;
  }

  get editOn() {
    return this._editOn;
  }

  set editOn(value) {
    this._editOn = value;
  }

  get comments() {
    return this._comments;
  }

  set comments(value) {
    this._comments = value;
  }

  get likes() {
    return this._likes;
  }

  set likes(value) {
    this._likes = value;
  }

  get userId() {
    return this._userId;
  }

  set userId(value) {
    this._userId = value;
  }

  get userName() {
    return this._userName;
  }

  set userName(value) {
    this._userName = value;
  }

  get classification() {
    return this._classification;
  }

  set classification(value) {
    this._classification = value;
  }

  get draft() {
    return this._draft;
  }

  set draft(value) {
    this._draft = value;
  }

  get updateOn() {
    return this._updateOn;
  }

  set updateOn(value) {
    this._updateOn = value;
  }

  get disabled() {
    return this._disabled;
  }

  set disabled(value) {
    this._disabled = value;
  }

  get tags() {
    return this._tags;
  }

  set tags(value) {
    this._tags = value;
  }

  addTags(value) {
    this._tags.push(value);
  }
}
